import { ArrowDropDown } from '@mui/icons-material';
import { Box, Button, ClickAwayListener, Paper, Popper } from '@mui/material';
import { TreeView } from '@progress/kendo-react-treeview';
import { without } from 'lodash';
import { useMemo, useState } from 'react';

import { OrganizationUnit, useOrgTree } from '~/data/orgunits';
import { convertListToTreeOptions } from '~/scenes/PortalModules/Analytics/common/ReportDatasetSelector/ReportTypeSelector/ReportUnitSelector/data';
import { useSxStyles } from '~/scenes/PortalModules/Analytics/common/ReportDatasetSelector/ReportTypeSelector/ReportUnitSelector/useStyles';

type PropsType = {
  value?: number;
  onChange: (value?: number) => void;
  organizationTree: OrganizationUnit[];
  unitOptions?: number[];
};

export const ReportUnitSelector = (props: PropsType) => {
  const { value, onChange, unitOptions } = props;

  const sxStyles = useSxStyles();

  const { orgTree } = useOrgTree();

  const [expanded, onExpand] = useState<number[]>([]);

  const { optionTree, selectedUnit } = useMemo(() => {
    return convertListToTreeOptions(orgTree, expanded, value, unitOptions);
  }, [orgTree, expanded, value, unitOptions]);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  return (
    <ClickAwayListener
      onClickAway={() => {
        setAnchorEl(null);
      }}
    >
      <Box sx={sxStyles.root}>
        <Button onClick={handleClick} endIcon={<ArrowDropDown />}>
          {selectedUnit?.fTreeUnitName ?? 'Select unit'}
        </Button>
        <Popper
          open={!!anchorEl}
          anchorEl={anchorEl}
          placement={'bottom-start'}
          sx={{ zIndex: 50 }}
        >
          <Paper sx={sxStyles.treeView}>
            <TreeView
              data={optionTree}
              expandIcons={true}
              onExpandChange={(event) => {
                const {
                  item: { id },
                } = event;

                const unitId = parseInt(id);

                if (unitId) {
                  onExpand(
                    expanded.includes(unitId)
                      ? without(expanded, unitId)
                      : [...expanded, unitId],
                  );
                }
              }}
              onItemClick={(event) => {
                const {
                  item: { id },
                } = event;
                const unitId = parseInt(id);

                if (!isNaN(unitId)) {
                  onChange(unitId);
                }
              }}
            />
          </Paper>
        </Popper>
      </Box>
    </ClickAwayListener>
  );
};
